import React from 'react'
import styled from 'styled-components'
import media from 'css-in-js-media'

import SwiperCore, { Navigation, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

// install Swiper components
SwiperCore.use([Navigation, Autoplay])

// Import Swiper styles
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'
import { Row, Col } from 'react-styled-flexboxgrid'
import { H2, H3, Overline } from './Typography'

import LeftIcon from '../svg/caret-left.svg'
import RightIcon from '../svg/caret-right.svg'
import { Variables } from '../styles/Variables'

const StyledHighlights = styled(Row)`
    text-align: center;
    width: 100%;
    margin: 0;
    padding-top: 80px;
    padding-bottom: 80px;

    ${media('<desktop')} {
        display: none;
    }

    ${Col} {
        width: 100%;
        position: relative;
        padding: 40px 8px;
    }

    ${Overline} {
        font-family: ${Variables.font.title};
        color: ${Variables.color.cocoa};
        margin-top: 20px;
    }
`

const HighlightsSlider = styled(Swiper)`
    &.swiper-container {
        margin-top: 80px;
        margin-bottom: 80px;
    }

    ${media('>=desktop')} {
        display: none;
    }

    ${Overline} {
        margin-bottom: 20px;
    }
`


const Arrow = styled.div`
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 100;
    cursor: pointer;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.swiper-button-disabled {
        opacity: 0.5;
    }

    svg path {
        stroke: white;
    }
`

const ArrowLeft = styled(Arrow)`
    left: 0;
`

const ArrowRight = styled(Arrow)`
    right: 0;
`

const Highlights: React.FC<{
    data?: object
}> = ({ data }) => {
    return (
        <>
            <StyledHighlights>
                {data.highlights.map((highlight, index) => {
                    return (
                        <Col md={true} key={index}>
                            <H3 center={true}>{highlight.title}</H3>
                            <Overline center={true}>{highlight.highlight}</Overline>
                        </Col>
                    )
                })}
            </StyledHighlights>
            <HighlightsSlider
                navigation={{
                    prevEl: '.prev',
                    nextEl: '.next',
                }}
                autoplay={{
                    delay: 5000,
                }}
                loop={true}
            >
                {data.highlights.map((highlight, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <H3 center={true}>{highlight.title}</H3>
                            <Overline center={true}>{highlight.highlight}</Overline>
                        </SwiperSlide>
                    )
                })}
                <ArrowLeft className="prev">
                    <LeftIcon />
                </ArrowLeft>
                <ArrowRight className="next">
                    <RightIcon />
                </ArrowRight>
            </HighlightsSlider>
        </>
    )
}

export default Highlights